/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const contactCreateBodyPriorityMax = 100;

export const ContactCreateBody = zod.object({
  kind: zod.enum(['email', 'telephone']),
  destination: zod.string(),
  label: zod.string(),
  priority: zod.int().min(1).max(contactCreateBodyPriorityMax),
  smsEnabled: zod.boolean().optional(),
  voiceEnabled: zod.boolean().optional(),
});

export type ContactCreateBody = zod.input<typeof ContactCreateBody>;
export type ContactCreateBodyOutput = zod.output<typeof ContactCreateBody>;
